import { render } from "./BouncedLeads.vue?vue&type=template&id=35d44396"
import script from "./BouncedLeads.vue?vue&type=script&lang=js"
export * from "./BouncedLeads.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__